export const initialState = ['dashboard'];

const NavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_NAV':
      return action.payload;
    default:
      return state;
  }
};

export default NavigationReducer;
